import { createFileRoute, redirect } from '@tanstack/react-router'
import { SequenceList } from '@/features/sequences/sequence-list'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for the document sequences screen (design spec §6.3).
 *
 * The grant gate is presentation only — the API enforces `company.view` on
 * the document-sequence endpoints; this only keeps a user without the grant
 * out of a screen they cannot use.
 */
export const Route = createFileRoute('/_authenticated/sequences')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'company.view')) {
      throw redirect({ to: '/' })
    }
  },
  component: SequenceList,
})
